import {
  FETCH_PROFILE_DATA,
  FETCH_PROFILE_DATA_TOTAL,
  FETCH_PROFILE_DATA_ERROR,
  FETCH_PROFILE_DATA_LOADING,
} from "../constants";
import gql from "graphql-tag";
import client from "../apolloClient";

export function profileDataFetchData(fetchQuery = null, limit = 15, page = 1) {
  return (dispatch, getState) => {
    dispatch(profileDataIsLoading(true));
    let state = getState();
    let query;

    let where;
    if (state.filterValue === 1) {
      where = `[
        {profile_user_id: { _eq: ${state.user.id} }},
        {profile_system: { _eq: 1 }}
      ]`;
    } else {
      where = `[
        {profile_user_id: { _eq: ${state.user.id} }},
        {profile_team_id: { _eq: ${state.filterValue} }},
        {profile_system: { _eq: 1 }}
      ]`;
    }

    if (fetchQuery) {
      query = fetchQuery;
    } else {
      query = gql`
        {
          simcaa_t_profiles(
            where: {
              _or: ${where}
            },
            limit: ${limit},
            offset: ${(page - 1) * limit}
          ) {
            id
            profile_conf
            profile_name
            profile_system
            profile_user_id
            profile_team_id
            team {
              name
            }
            user {
              user
            }
          }
          simcaa_t_profiles_aggregate(
            where: {
              _or: ${where}
            }) {
              aggregate {
                count
            }
          }
        }
      `;
    }

    client
      .query({ query })
      .then((data) => {
        dispatch(profileDataIsLoading(false));
        if (data.networkStatus !== 7) {
          dispatch(profileDataHasErrored(true));
        } else {
          dispatch(profileDataHasErrored(false));
          let finalData = data.data.simcaa_t_profiles.map((item) => {
            const { team, user, ...props } = item;
            return {
              ...props,
              user_name: user.user,
              team_name: team.name,
            };
          });
          dispatch(profileDataFetchDataSuccess(finalData));
          dispatch(
            profileDataFetchDataTotal(
              data.data.simcaa_t_profiles_aggregate.aggregate.count
            )
          );
        }
      })
      .catch((error) => {
        dispatch(profileDataIsLoading(false));
        dispatch(profileDataHasErrored(true));
      });
  };
}

export function profileDataCreateData(mutationQuery, data) {
  return (dispatch) => {
    dispatch(profileDataIsLoading(true));

    client
      .mutate({ mutation: mutationQuery, variables: { objects: [data] } })
      .then((data) => {
        dispatch(profileDataIsLoading(false));
        if (data.data) {
          dispatch(profileDataHasErrored(false));
          dispatch(profileDataFetchData());
        } else {
          dispatch(profileDataHasErrored(true));
        }
      })
      .catch((error) => {
        dispatch(profileDataIsLoading(false));
        dispatch(profileDataHasErrored(true));
      });
  };
}

export function profileDataUpdateData(mutationQuery, variables = {}) {
  return (dispatch) => {
    dispatch(profileDataIsLoading(true));

    client
      .mutate({ mutation: mutationQuery, variables })
      .then((data) => {
        dispatch(profileDataIsLoading(false));
        if (data.data) {
          dispatch(profileDataHasErrored(false));
          dispatch(profileDataFetchData());
        } else {
          dispatch(profileDataHasErrored(true));
        }
      })
      .catch((error) => {
        dispatch(profileDataIsLoading(false));
        dispatch(profileDataHasErrored(true));
      });
  };
}

export function profileDataDeleteData(id) {
  return (dispatch) => {
    dispatch(profileDataIsLoading(true));
    let query = gql`
      mutation deleteProfile {
        delete_simcaa_t_profiles(where: { id: { _eq: ${id} } }) {
          affected_rows
        }
      }
    `;
    client
      .mutate({ mutation: query })
      .then((data) => {
        dispatch(profileDataIsLoading(false));
        if (data.data) {
          dispatch(profileDataHasErrored(false));
          dispatch(profileDataFetchData());
        } else {
          dispatch(profileDataHasErrored(true));
        }
      })
      .catch((error) => {
        dispatch(profileDataIsLoading(false));
        dispatch(profileDataHasErrored(true));
      });
  };
}

export function profileDataHasErrored(bool) {
  return {
    type: FETCH_PROFILE_DATA_ERROR,
    hasErrored: bool,
  };
}

export function profileDataIsLoading(bool) {
  return {
    type: FETCH_PROFILE_DATA_LOADING,
    isLoading: bool,
  };
}

export function profileDataFetchDataSuccess(profileData) {
  return {
    type: FETCH_PROFILE_DATA,
    profile: profileData,
  };
}

export function profileDataFetchDataTotal(total) {
  return {
    type: FETCH_PROFILE_DATA_TOTAL,
    total,
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/ProfileFetchActions.js